import fc from '@/firebaseConfig'
import { uploadToCurrentUserCompanyBucket } from '../../libs/imageUploader'

export default {
  namespaced: true,
  state: {
    loading: false,
    list: [],
  },
  getters: {
    listOptions(state) {
      return state.list.map(o => ({
        value: o.id,
        text: o.nameTH,
      }))
    }
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val
    },
    setList(state, val) {
      state.list = val
    },
  },
  actions: {
    async getList({ commit }, { companyId }) {
      commit('setLoading', true)
      const snapshot = await fc.db.collection("Companies").doc(companyId)
        .collection('Shops').get()
      let list = []
      snapshot.forEach((doc) => {
        let data = doc.data()
        data.id = doc.id
        list.push(data)
      });
      commit('setList', list)
      commit('setLoading', false)
      console.log('list: ', list)
      return list
    },
    async getData(_, { companyId, shopId }) {
      const snapshot = await fc.db.collection("Companies").doc(companyId)
        .collection('Shops').doc(shopId).get()

      return snapshot.data()
    },
    async create(_, { companyId, data, logo }) {
      const doc = fc.db.collection("Companies").doc(companyId)
        .collection('Shops').doc()
      
      const uploadResult = await uploadToCurrentUserCompanyBucket(logo, companyId, `Shops/${doc.id}/Logos`)
      await doc.set({
        ...data,
        logoImageUrl: uploadResult.imageUrl,
        logoImagePath: uploadResult.storagePath,
      })

      return doc.id
    },
    async update(_, { companyId, data, logo, id }) {
      const doc = fc.db.collection("Companies").doc(companyId)
        .collection('Shops').doc(id)

      if (logo) {
        const uploadResult = await uploadToCurrentUserCompanyBucket(logo, companyId, `Shops/${doc.id}/Logos`)
        data.logoImageUrl = uploadResult.imageUrl
        data.logoImagePath = uploadResult.storagePath
      }
      await doc.update(data)
    },
    async remove(_, { companyId, shopId }) {
      await fc.db.collection("Companies").doc(companyId)
        .collection('Shops').doc(shopId)
        .delete()
    }
  }
}

